
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

export interface UserProfile {
  ativo: boolean;
  celular: string;
  codpaiscelular: number;
  email: string;
  idioma: string;
  idperfil: number;
  idusuario: number;
  nome: string;
  regiao: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiBaseUrl}/api/me`;

  private userProfileSubject = new BehaviorSubject<UserProfile | null>(null);
  public userProfile$ = this.userProfileSubject.asObservable();

  private getTokenFromCookie(): string | null {
    const match = document.cookie.match(/(?:^|;\s*)token=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  private getAuthHeaders(): { headers: { Authorization: string } } | {} {
    const token = this.getTokenFromCookie();
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  }

  // Carrega o perfil (interceptor Autenticacao adiciona token automaticamente)
  loadUserProfile(): void {
    this.http.get<UserProfile>(this.apiUrl, this.getAuthHeaders()).subscribe({
      next: (profile) => this.userProfileSubject.next(profile),
      error: (err) => console.error('Erro ao carregar perfil:', err)
    });
  }

  get currentProfile(): UserProfile | null {
    return this.userProfileSubject.value;
  }

  clearProfile(): void {
    this.userProfileSubject.next(null);
  }

  getUserProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(this.apiUrl, this.getAuthHeaders());
  }

  updateUserProfile(profile: Partial<UserProfile>): Observable<UserProfile> {
    return this.http.put<UserProfile>(this.apiUrl, profile, this.getAuthHeaders());
  }
}
